module.exports = __webpack_public_path__ + "static/img/A85.f4ec5469.jpg";